import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { LOGIN_OWNER } from "../../actions/mutations";
import { useNavigate, Link } from "react-router-dom";
import NavbarAccount from "../Layout/Navbar_account";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { togglePassword } from "../../utils/togglePassword";
import editElem from "../../utils/editElem";

let emoji = Math.random() < 0.5 ? "🥳" : "🚀";

const LoginOwnerPage = () => {
  const navigate = useNavigate();
  if (!!sessionStorage.getItem("loggedIn")) navigate("/mon-compte");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginOwner] = useMutation(LOGIN_OWNER);
  // const [loginOwner, { data }] = useMutation(LOGIN_OWNER);

  document.title = "Carte Verte : Connexion";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const submitForm = (event) => {
    event.preventDefault();
    editElem(".smallLoader2", "display", "block");
    editElem("#login", "disabled", true);
    editElem(".networkError", "display", "none");
    editElem(".serverNetworkError", "display", "none");

    let error = false;
    const formattedEmail = email.trim().toLowerCase();
    if (
      !formattedEmail.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
      )
    ) {
      editElem(".emailError", "display", "block");
      error = true;
    }
    if (password.length < 8) {
      editElem(".passwordError", "display", "block");
      error = true;
    }
    if (error) {
      editElem("#login", "disabled", false);
      editElem(".smallLoader2", "display", "none");
    } else
      loginOwner({
        variables: {
          data: {
            email: formattedEmail,
            password,
          },
        },
      })
        .then((response) => {
          sessionStorage.setItem("loggedIn", true);
          navigate("/mon-compte");
          if (window.location.hostname == "www.carteverte.co") {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              window.dataLayer.push(arguments);
            }
            gtag("event", "login", {
              method: "Direct",
            });
          }
        })
        .catch((e) => {
          sessionStorage.removeItem("loggedIn");
          console.log(e.toString());
          if (
            e
              .toString()
              .includes("Echec de connexion : email ou mot de passe incorrect")
          ) {
            editElem(".loginError", "display", "block");
            console.warn(e.toString());
            if (window.location.hostname == "www.carteverte.co") {
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                window.dataLayer.push(arguments);
              }
              gtag("event", "error", {
                method: "Direct",
              });
            }
          } else if (
            e.toString().includes("Looks like an internal server error") || 
            e.toString().includes("Failed to fetch") 
          ) {
            editElem(".networkError", "display", "block");
            console.warn("Vérifer votre connexion internet");
          } else {
            console.log("okay", e.toString());

            editElem(".serverNetworkError", "display", "block");
            console.warn(
              " Notre serveur est déconnecté. Veuillez réessayer plus tard et nous contacter si cela persiste! contact@carteverte.co"
            );
          }
          editElem("#login", "disabled", false);
          editElem(".smallLoader2", "display", "none");
        });
  };

  // const pushResetPasswordPage = () => {
  //   history.push("/mot-de-passe-oublie");
  // };

  return (
    <div id="loginContainer">
      <NavbarAccount isActive="hidden" cta="no" />
      <div id="imgContainer">
        <Link to="/#">
          <img
            className="logoLoginSignup"
            src="/images/icon-blanche.png"
            alt=""
          />
        </Link>
      </div>
      <Link className="returnLink" to="/#">
        {/* <i className="fas fa-arrow-left" style={{ fontSize: "1.4rem" }}></i> */}
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
        />
        Accueil
      </Link>
      <div id="formContainer">
        <form id="form" onSubmit={submitForm}>
          <div id="formHeader">
            <h1 style={{ marginBottom: "2rem", textAlign: "center" }}>
              Se connecter
            </h1>

            <h1 id="bonjour">Bonjour !</h1>
            <h1 id="welcom">
              C'est parti pour un nouveau jour de fédélisation
            </h1>
            <span role="img"> {emoji}</span>
          </div>
          <div id="emailContainer">
            <p>EMAIL</p>
            <input
              placeholder="exemple@commerce.fr"
              type="text"
              onChange={(event) => {
                editElem(".emailError", "display", "none");
                editElem(".loginError", "display", "none");
                setEmail(event.target.value);
              }}
            />
            <p className="error emailError">Email invalide !</p>
          </div>
          <div id="passwordContainer">
            <p>MOT DE PASSE</p>
            <div style={{ position: 'relative' }}>
              <input
                id="psw"
                placeholder="8 caractère ou plus"
                type={showPassword ? "text" : "password"}
                onChange={(event) => {
                  editElem(".passwordError", "display", "none");
                  editElem(".loginError", "display", "none");
                  setPassword(event.target.value);
                }}
              />
              <span 
                onClick={togglePasswordVisibility}
                style={{ 
                  position: 'absolute', 
                  right: '10px', 
                  top: '50%', 
                  transform: 'translateY(-50%)', 
                  cursor: 'pointer',
                  color: '#666',
                  fontSize: '1.2rem',
                  userSelect: 'none'
                }}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>
            <p className="error passwordError">
              Le mot de passe contient au moins 8 caractères !
            </p>
          </div>
          <div className="cnx">
            <button
              id="login"
              type="submit"
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-around",
                width: "16rem",
              }}
            >
              Me connecter
              <div className="smallLoader2"></div>
            </button>
            <div className="forgotten">
              <p>
                <Link className="pwForgotten" to="/mot-de-passe-oublie">
                  Mot de passe oubié ?
                </Link>
              </p>
            </div>
          </div>
          <p className="error loginError">Email ou mot de passe incorrect</p>
          <p className="error networkError">
            Veuillez Vérifier votre connexion internet !
          </p>
          <p className="error networkError serverNetworkError">
            Notre serveur est déconnecté. Veuillez réessayer plus tard et nous
            contacter si cela persiste! contact@carteverte.co
          </p>
        </form>
      </div>
      <p id="noAccount">
        Vous n'avez pas encore de compte ?{" "}
        <span role="img" aria-label="">
          🥺
        </span>{" "}
        <span>
          <Link to="/signup">Adhérez maintenant.</Link>
        </span>
      </p>
    </div>
  );
};

export { LoginOwnerPage as default };
